export default {
    administrators: 'Administrators',
    administratorsTeam:
        'Administrators can see all data and manage company settings',
    approvalTemplatesSection: {
        approvalTemplateName: 'Flow Name',
        approvalTemplates: 'Approval Flows',
        approvalTemplatesSubtitle: 'Approval Flows that use this group/role',
    },
    clientSection: {
        clientName: 'Client Name',
        clients: 'Clients',
        emptyClients: 'No clients have been assigned to this group yet',
        subtitleClient: 'Clients that are managed by this group',
    },
    deletionModalContent: {
        approvalFlowsDeleteConfirm:
            "The following documents' Approval Requests will be cancelled since they use this group/role:",
        deleteGroup:
            'Deleting the group will not remove documents or clients associated to it, but will make them visible to the entire organization. Are you sure you want to delete this group?',
        deleteRole: 'Are you sure you want to delete this role?',
        titleGroup: 'Delete Group',
        titleRole: 'Delete Role',
    },
    membersSection: {
        emptyMembersGroup: 'This group has no members yet',
        emptyMembersRole: 'No members have been assigned to this role yet',
        memberName: 'Member Name',
    },
    subtitleGroup:
        'Documents and clients owned by a group are only visible to members of the group',
    subtitleRole:
        'Assign team members to different functional roles within your company',
};
